import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Navbar, Footer, Loading, Breadcrumbs, ConfirmModal } from "../../components/shared";
import { toast } from 'react-toastify';
import { logOutClientCleanUp } from "../../utils/Utilities";
import { logoutUser } from '../../redux/slice/userSlice'; // Import the logoutUser action

const Logout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [showConfirmationModal, setShowConfirmationModal] = useState(true);
  const [loggingOut, setLoggingOut] = useState(false);

  const showErrorToast = (message) => toast.error(message);

  // Logout logic
  const handleLogout = async () => {
    setLoggingOut(true);
    try {
      localStorage.removeItem('postLoginRedirect');
      const logoutTypeFromURL = new URLSearchParams(location.search).get('logoutType')?.trim() || 'full-logout';
      await logOutClientCleanUp(logoutTypeFromURL);
    } catch (error) {
      console.error("Error during logout:", error);
      showErrorToast("An error occurred during logout.");
    } finally {
      dispatch(logoutUser());
      navigate('/auth/login');
    }
  };

  return (
    <>
      <Navbar />
      <div className="general_parent">
        <div className="general_container">
          <div className="general_body">
            <Breadcrumbs /><br />
            {loggingOut ? <Loading /> : <p>வெளியேறுவதை உறுதிப்படுத்துங்கள்...</p>}
          </div>
        </div>
      </div>
      {showConfirmationModal && (
        <ConfirmModal
          title="நீங்கள் நிச்சயமாக வெளியேற விரும்புகிறீர்களா?"
          confirmText="ஆம், வெளியேறு"
          cancelText="இல்லை, திரும்பவும்"
          onConfirm={() => {
            setShowConfirmationModal(false);
            handleLogout();
          }}
          onCancel={() => {
            setShowConfirmationModal(false);
            navigate(-1);
          }}
        />
      )}

      <Footer />
    </>
  );
};

export default Logout;
